import React, { Fragment } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import MasterReferenceForm from '@shared/MasterReferenceForm'

const Content = ({ user }) => {
  const { id } = useParams()
  const navigate = useNavigate()

  const handleSave = () => {
    Swal.fire({
      text: 'Master reference updated!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })

    navigate('/settings/master-references')
  }

  return (
    <Fragment>

      <Title text='Edit Master Reference' user={user}/>

      <MasterReferenceForm
        id={id}
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}
const EditMasterReference = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default EditMasterReference
